<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7507 5.30859H18.0608C18.9338 5.30859 19.6417 5.96547 19.6417 6.77579L19.645 11.6584H10.1172L10.1693 6.77579C10.1693 5.96547 10.8771 5.30859 11.7507 5.30859Z"
      stroke="#E10E1C"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.7051 18.0075H18.0544"
      stroke="#F8B824"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8796 2.13379V5.06147"
      stroke="#E10E1C"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M37.1023 14.833V16.0258"
      stroke="#E10E1C"
      stroke-width="2.53"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M24 46V13.5451C24 12.7197 23.3325 12 22.4165 12H6.58352C5.66748 12 5 12.7197 5 13.5451V46"
      stroke="#E10E1C"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.7051 24.3571H18.0544"
      stroke="#F8B824"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.7051 30.7068H18.0544"
      stroke="#F8B824"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.7051 37.0564H18.0544"
      stroke="#F8B824"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.75 22.5622C29.75 21.1236 30.8592 19.75 32.4997 19.75H41.4998C43.1405 19.75 44.25 21.1233 44.25 22.5622V44.75H47C47.6904 44.75 48.25 45.3096 48.25 46C48.25 46.6904 47.6904 47.25 47 47.25H43C42.3096 47.25 41.75 46.6904 41.75 46V22.5622C41.75 22.4599 41.7107 22.3741 41.6605 22.3201C41.6167 22.2731 41.5671 22.25 41.4998 22.25H32.4997C32.4329 22.25 32.3834 22.2729 32.3395 22.32C32.2893 22.374 32.25 22.4599 32.25 22.5622V45.9978V46C32.25 46.6041 31.8215 47.108 31.2519 47.2246C31.1705 47.2413 31.0863 47.25 31 47.25H2C1.30964 47.25 0.75 46.6904 0.75 46C0.75 45.3096 1.30964 44.75 2 44.75H29.75V22.5622Z"
      fill="#E10E1C"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
